import { ModDashboardStructure } from 'open-modules/zdf/structure/moddashboard';
import { VideoVotingStructure } from 'open-modules/zdf/structure/videovoting';
import { MigrationsStructure } from 'system/migrations';
import type { Structure } from 'util/stdtypes';

import { AccountStructure } from './account';
import { AdminStructure } from './admin';
import { ArticleStructure } from './article';
import { ComponentDemoStructure } from './componentdemo';
import { EMBEDDABLE_SIDEBAR_STRUCTURES, SPECIAL_SCREENS } from './constants';
import { DeveloperToolsStructure } from './developer-tools';
import { EditorialDashStructure } from './editorial-dash';
import { LoginStructure } from './login';
import { ModerationDashStructure } from './moderation-dash';
import { ProfileStructure } from './profile';
import { QuestionStructure } from './question';
import { SettingsStructure } from './settings';
import { SimpleCommentsStructure } from './simple-comments';
import { TopicStructure } from './topic';

export const structures: Structure<any>[] = [
    QuestionStructure,
    ModerationDashStructure,
    ArticleStructure,
    VideoVotingStructure,
    TopicStructure,
    SimpleCommentsStructure,
    ComponentDemoStructure,
    ProfileStructure,
    MigrationsStructure,
    LoginStructure,
    AdminStructure,
    AccountStructure,
    ModDashboardStructure,
    EditorialDashStructure,
    SettingsStructure,
    DeveloperToolsStructure,
];
